import React, { useRef, useState } from "react";
import { uploadFile, downloadAuthed } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Upload, Download, FileUp } from "lucide-react";
import { toast } from "sonner";

export const ImportButton = ({ kind, onDone }) => {
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(null);
  const fileRef = useRef();

  const doImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const r = await uploadFile(`/import/${kind}`, file);
      setResult(r);
      toast.success(`${r.created} row(s) imported`);
      onDone && onDone();
    } catch {
      toast.error("Import failed");
    }
    if (fileRef.current) fileRef.current.value = "";
  };

  return (
    <>
      <Button variant="outline" onClick={() => { setResult(null); setOpen(true); }} data-testid={`import-${kind}-btn`}>
        <FileUp className="w-4 h-4 mr-1" /> Import
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle className="font-heading capitalize">Import {kind}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-slate-500">Download the template, fill in your data, then upload the .xlsx file. Rows are validated and errors are reported.</p>
            <Button variant="outline" className="w-full" onClick={() => downloadAuthed(`/import/${kind}/template`, `${kind}_template.xlsx`)} data-testid={`template-${kind}-btn`}>
              <Download className="w-4 h-4 mr-1" /> Download Template
            </Button>
            <input ref={fileRef} type="file" accept=".xlsx" className="hidden" onChange={doImport} data-testid={`import-${kind}-file`} />
            <Button className="w-full bg-indigo-600 hover:bg-indigo-700" onClick={() => fileRef.current?.click()} data-testid={`import-${kind}-upload`}>
              <Upload className="w-4 h-4 mr-1" /> Choose File & Import
            </Button>
            {result && (
              <div className="text-sm border rounded-md p-3 bg-slate-50">
                <p className="text-emerald-600 font-medium">{result.created} imported</p>
                {result.errors?.length > 0 && (
                  <ul className="mt-2 text-rose-600 space-y-0.5 max-h-40 overflow-y-auto">
                    {result.errors.map((er, i) => <li key={i}>{er}</li>)}
                  </ul>
                )}
              </div>
            )}
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Close</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
